import { Box, Flex } from '@chakra-ui/react';
import _get from 'lodash/get';
import { useForm, useFormState } from 'react-final-form';

import {
  hausbankFieldsWithSectionString,
  HausbankFieldTypes,
  PurposeOptionsItem,
} from 'hausbank/inquiry/fields';
import { HausbankPurposeKinds } from 'hausbank/inquiry/steps/financingNeed/sections/purposeSection/purposeKinds/purposeKinds';
import { HiddenInput } from 'theme/components/accessibility/HiddenInput';
import { TextComponent } from 'theme/components/Text';
import { useTranslations } from 'utils/hooks/useTranslations';

const transition = 'all 0.3s ease-in-out';
const { sectionString: purposeKind } =
  hausbankFieldsWithSectionString.financingNeedPage.purposeSection.purposeKind;

type Props = {
  purposeKindItem: HausbankPurposeKinds;
};

export const PurposeKindItem = ({ purposeKindItem }: Props) => {
  const IconComponent = purposeKindItem.icon;
  const t = useTranslations();
  const { change } = useForm();
  const { values } = useFormState<HausbankFieldTypes>();

  const id = `${purposeKind}-${purposeKindItem.id}`;
  const purposeKindValue = _get(values, purposeKind);
  const isActive = purposeKindValue.some(
    (item: PurposeOptionsItem) => item.id === purposeKindItem.id,
  );

  const handleChange = () => {
    const isItemSelected = purposeKindValue.some(
      (item: PurposeOptionsItem) => item.id === purposeKindItem.id,
    );
    if (isItemSelected) {
      change(
        purposeKind,
        purposeKindValue.filter((item: PurposeOptionsItem) => item.id !== purposeKindItem.id),
      );
    } else {
      change(purposeKind, [...purposeKindValue, { id: purposeKindItem.id }]);
    }
  };

  return (
    <Box>
      <HiddenInput
        id={id}
        type="checkbox"
        name={purposeKind}
        onChange={handleChange}
        value={purposeKindItem.id}
      />
      <Flex
        as="label"
        flexDirection="column"
        alignItems="center"
        gap={4}
        sx={{
          ...(isActive
            ? {}
            : {
                '&:hover': {
                  '.icon-container': { borderColor: 'brand.default' },
                  '.icon': { stroke: 'brand.default' },
                  '.text': { color: 'brand.default' },
                },
              }),
          cursor: 'pointer',
        }}
        htmlFor={id}
        data-testId={purposeKindItem.id}
        role="button"
      >
        <Box
          className="icon-container"
          border="2px"
          borderColor={isActive ? 'brand.default' : 'border.darkGrey'}
          backgroundColor={isActive ? 'brand.default' : 'initial'}
          p={8}
          transition={transition}
        >
          <IconComponent
            className="icon"
            stroke={isActive ? 'white' : 'border.darkGrey'}
            width={40}
            height={24}
            display="block"
            transition={transition}
          />
        </Box>
        <TextComponent
          className="text"
          color={isActive ? 'brand.default' : 'text.tertiary'}
          transition={transition}
        >
          {t(purposeKindItem.translationString)}
        </TextComponent>
      </Flex>
    </Box>
  );
};
